import React from "react";
import PATH from "constants/path";
import { illust08, illust02, illust03, illust01 } from "assets/img";
import { ChevronRightGreen } from "assets/svg";
import { isAuthenticated } from "utils/common";

function FirstJoin() {
  return (
    <div className={isAuthenticated() ? "w-80" : "itsumoni container px-0"}>
      <div className="bg-green text-white py-2 text-center position-relative sp-1 fw-600 z-index-2">
        <div className="fs-12 lh-21">＼空いた時間で、気軽にモニター／</div>
        <div className="fs-20 fs-sm-18">はじめての方へ</div>
        <img
          className="position-absolute top-100 end-0 translate-middle-y img-w"
          src={illust01}
          alt={illust01}
        ></img>
      </div>

      <div className="px-3 px-md-5 py-4 text-lg-center bg-brown z-index-1">
        <div className="text-grey mb-4 fw-600 mt-1 mt-md-3">
          「いつモニ」とは
          <span className="text-green text-decoration-underline cursor-pointer">
            <a href="https://www.architect.co.jp/" target="_blank">
              株式会社アーキテクト
            </a>
          </span>
          が運営するトライアルモニターサイトです。
        </div>
        <div className="list-first-step mt-3">
          <div className="step-item">
            <div className="title">
              <div>STEP1</div>
              <div className="sub-title">会員登録する</div>
              <div className="image">
                <img src={illust08} alt="illust08" />
              </div>
            </div>
            <div className="mt-3 mb-1 lh-21">
              お名前や生年月日などの会員情報を入力し、ご登録のメールアドレスに送付される確認メールのURLをクリックすると、会員登録が完了します。
            </div>
            {!isAuthenticated() && (
              <div className="more">
                <a href={PATH.COMMON + PATH.SIGNUP}>
                  会員登録
                  <span className="ms-2">
                    <ChevronRightGreen />
                  </span>
                </a>
              </div>
            )}
            <span className="triangle"></span>
          </div>
          <div className="step-item">
            <div className="title">
              <div>STEP2</div>
              <div className="sub-title">案件に参加する</div>
              <div className="image">
                <img src={illust02} alt="illust02" />
              </div>
            </div>
            <div className="mt-3 mb-1 lh-21">
              登録会員数は100万人を突破。エステ体験や商品のトライアルなど多数のモニター案件を掲載しています。
            </div>
            <div className="more">
              <a href={PATH.GUIDE}>
                ご利用方法
                <span className="ms-2">
                  <ChevronRightGreen />
                </span>
              </a>
            </div>
            <span className="triangle"></span>
          </div>
          <div className="step-item">
            <div className="title">
              <div>STEP3</div>
              <div className="sub-title">謝礼をゲット!</div>
              <div className="image">
                <img src={illust03} alt="illust03" />
              </div>
            </div>
            <div className="mt-3 mb-1 sp-14 lh-21">
              モニター案件にご参加いただき達成条件を満たすとポイントが付与されます。毎月末に1,000ポイント超えた時点で自動的に登録口座へお振込しますので、奮ってお気軽にご参加ください。
            </div>
            <div className="more">
              <a href={PATH.POINT}>
                ポイントについて
                <span className="ms-2">
                  <ChevronRightGreen />
                </span>
              </a>
            </div>
            <span className="triangle"></span>
          </div>
        </div>

        <div className="w-question mt-5 mb-3">
          <a href={PATH.QUESTIONS}>
            <span className="me-3 fs-icon">
              <i className="bi bi-question-circle-fill"></i>
            </span>
            よくあるご質問
          </a>
        </div>
      </div>
    </div>
  );
}

export default FirstJoin;
